<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h4 v-if="!propOpenedInModal" class="card-title">{{ cvCardTitle }}</h4>
          <ValidationObserver ref="Batch">
            <form action="#">
              <div class="form-row">
                <!-- Batch Start Date -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_start_date">{{cvBatchStartDateLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchStartDate" rules="required" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_start_date"
                      type="date"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Start Time -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_start_time">{{cvBatchStartTimeLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchStartTime" rules="required" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_start_time"
                      placeholder="Enter Batch Start Time"
                      type="time"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Days -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_days">{{cvBatchDaysLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchDays" :rules="{ required: true, regex: /^[a-zA-Z0-9 '.-]*$/ }" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_days"
                      placeholder="Enter Batch Days"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                    <span><small>EX:- Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday</small></span>
                  </ValidationProvider>
                </div>

                <!-- Batch Mode -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_mode">{{cvBatchModeLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchMode" rules="required" v-slot="{ errors }">
                    <select
                      id="validationbatch_mode"
                      v-model="vmBatchFormData.batch_mode"
                      class="form-control"
                      required                    >
                      <option :value="null" disabled>Select Batch Mode</option>
                      <option value="Online">Online</option>
                      <option value="Offline">Offline</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Type -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_type">{{cvBatchTypeLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchType" rules="required" v-slot="{ errors }">
                    <select
                      id="validationbatch_type"
                      v-model="vmBatchFormData.batch_type"
                      class="form-control"
                      required
                    >
                      <option :value="null" disabled>Select Batch Type</option>
                      <option value="Group">Group</option>
                      <option value="Individual">Individual / 1 On 1</option>
                      <option value="Workshop">Workshop</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Fees -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_fees">{{cvBatchFeesLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchFees" :rules="{ required: true, regex: /^[0-9]+(\.[0-9]{1,2})?$/ }" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_fees"
                      placeholder="Enter Batch Fees"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Link -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_link">{{cvBatchLinkLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchLink" :rules="{ required: true, regex: /^((https?:\/\/)?[\w-]+(\.[\w-]+)+[/#?]?.*|\/.*)$/ }" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_link"
                      placeholder="Enter Batch Link"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Link Type -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_link_type">{{cvBatchLinkTypeLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchLinkType" rules="required" v-slot="{ errors }">
                    <select
                      id="validationbatch_link_type"
                      v-model="vmBatchFormData.batch_link_type"
                      class="form-control"
                      required
                    >
                      <option :value="null" disabled>Select Batch Link Type</option>
                      <option :value="0">New Tab</option>
                      <option :value="1">Modal</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Module (Updated to handle scalar value assignment) -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_module">{{cvBatchModuleLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchModule" rules="required" v-slot="{ errors }">
                    <multiselect
                      v-model="selectedProduct"
                      :options="productOptions"
                      placeholder="Search Product Name"
                      track-by="key"
                      label="text"
                      :searchable="true"
                      :multiple="false"
                      :close-on-select="true"
                      :clear-on-select="true"
                      class="mt-2"
                      @select="onProductSelect"
                      @remove="onProductRemove">
                      <span slot="noResult">No products found</span>
                    </multiselect>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <!-- Batch Module Id -->
                <div class="col-md-12 mb-3">
                  <label for="validationbatch_module_id">{{cvBatchModuleIdLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="BatchModuleId" :rules="{ required: true, regex: /^[a-zA-Z0-9_-]+$/ }" v-slot="{ errors }">
                    <input
                      v-model="vmBatchFormData.batch_module_id"
                      placeholder="Enter Batch Module Id"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="tprepBatchAdd()"> {{ cvSubmitBtn }} </button>
              </div>
            </form>
          </ValidationObserver>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { Batchs } from "../../../FackApi/api/TprepBatch.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit"
import userPermission from "../../../Utils/user_permission.js"
import productName from "../../../FackApi/json/productName.json"
import Multiselect from "vue-multiselect"
import { ValidationProvider, ValidationObserver } from "vee-validate"

export default {
  name: "tprepBatchAdd",
  components: {
    Multiselect,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Add Batch",
      cvSubmitBtn: "Add",
      cvBatchStartDateLabel: "Batch start date",
      cvBatchEndDateLabel: "Batch end date",
      cvBatchStartTimeLabel: "Batch start time",
      cvBatchEndTimeLabel: "Batch end time",
      cvBatchDaysLabel: "Batch days",
      cvBatchModeLabel: "Batch mode",
      cvBatchTypeLabel: "Batch type",
      cvBatchFeesLabel: "Batch fees",
      cvBatchLinkLabel: "Batch link",
      cvBatchLinkTypeLabel: "Batch link type",
      cvBatchModuleLabel: "Batch module",
      cvBatchModuleIdLabel: "Batch module id",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Batch Added",
      selectedProduct: null,
      vmBatchFormData: Object.assign({}, this.initFormData()),
      vmBatchDesc: null,
      vmBatchType: null,
      productOptions: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    if (this.userData.user_role == "USERROLE11114") {
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.loadProductOptions()
  },
  methods: {
    /**
     * load Product Options
     */
    loadProductOptions () {
      if (productName) {
        this.productOptions = Object.keys(productName).map(key => {
          return {
            key: key,
            text: productName[key]
          }
        })
      }
    },
    /**
     * Handle selection from Multiselect
     */
    onProductSelect (selectedOption) {
      console.log("selectedOption", selectedOption)
      // Stores the string value (e.g. "GIDE Plus") instead of the whole object
      this.vmBatchFormData.batch_module = selectedOption.key
      // If you need the key instead (e.g. "PRODUCT01"), change `.text` to `.key`
    },
    /**
     * Handle removal from Multiselect
     */
    onProductRemove () {
      this.vmBatchFormData.batch_module = null
    },
    /**
     * initFormData
     */
    initFormData () {
      this.selectedProduct = null
      return {
        "batch_start_date": "",
        "batch_start_time": "",
        "batch_days": "",
        "batch_mode": null,
        "batch_type": null,
        "batch_fees": "",
        "batch_link": "",
        "batch_link_type": null,
        "batch_module": null,
        "batch_module_id": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmBatchFormData) {
          if (!this.vmBatchFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * tprepBatchAdd
     */
    async tprepBatchAdd () {
      let isValid = await this.$refs.Batch.validate()
      if (!isValid) {
        return
      }

      try {
        this.cvLoadingStatus = true
        let BatchAddResp = await Batchs.tprepBatchAdd(this, this.vmBatchFormData)
        await ApiResponse.responseMessageDisplay(this, BatchAddResp)
        if (BatchAddResp && !BatchAddResp.resp_status) {
          return false
        }
        if (this.propOpenedInModal) {
          this.$emit("emitCloseBatchAddModal", BatchAddResp.resp_data)
        }
        this.vmBatchFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at tprepBatchAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
